import { render } from "./PercentProgress.vue?vue&type=template&id=3aadaa74&scoped=true"
import script from "./PercentProgress.vue?vue&type=script&lang=js"
export * from "./PercentProgress.vue?vue&type=script&lang=js"

import "./PercentProgress.vue?vue&type=style&index=0&id=3aadaa74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3aadaa74"

export default script